import { LockOpen, LockOutlined } from "@mui/icons-material";
import { SxProps } from "@mui/material";
import ButtonIcon from "components/controls/buttons/ButtonIcon";
import { FunctionComponent } from "react";
import querySo from "stores/route/query";



interface Props {
}

const FilterLockButton: FunctionComponent<Props> = ({
}) => {

	// HOOKs

	// HANDLERs
	const handleClick = () => {
		querySo.setBlockFilter(!querySo.state.blockFilter)
	}

	// RENDER
	const sxButton: SxProps = {
		bgcolor: querySo.state.blockFilter ? "secondary.main" : "grey.light",
		width: 24,
		height: 24
	}
	const tooltip = querySo.state.blockFilter ? "FILTERS BLOCKED FOR ALL PAGES" : "FILTERS FOR THIS PAGE ONLY"

	return <ButtonIcon sx={sxButton}
		onClick={handleClick}
		tooltip={tooltip}
	>
		{querySo.state.blockFilter
			? <LockOpen sx={sxIconOpen} />
			: <LockOutlined sx={sxIconClose} />
		}
	</ButtonIcon>
}

export default FilterLockButton

const sxIconOpen: SxProps = {
	color: "secondary.contrastText",
	width: "16px",
	height: "16px"
}

const sxIconClose: SxProps = {
	color: "text.negative",
	width: "16px",
	height: "16px"
}